// import React, { useState, useEffect } from "react";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { FiX } from "react-icons/fi";
// import toast from "react-hot-toast";
// import API from "../api/config";
// import WLogo from "../assets/TravelXOXO 1.png";
// import DLogo from "../assets/TravelXOXO 2.png";
// import { Link } from "react-router-dom";


// const AdminLogin = () => {
//    const [theme, setTheme] = useState("dark");
  
//     const toggleTheme = () => {
//       setTheme((prev) => (prev === "light" ? "dark" : "light"));
//     };
  
//     useEffect(() => {
//       document.documentElement.classList.remove("light", "dark");
//       document.documentElement.classList.add(theme);
//     }, [theme]);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Forgot password states
//   const [showForgot, setShowForgot] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [step, setStep] = useState(1); // 1 = email, 2 = otp + new password
//   const [newPassword, setNewPassword] = useState("");

//   const [showNewPassword, setShowNewPassword] = useState(false);

//   // 🔐 ADMIN LOGIN
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       setLoading(true);
//       const { data } = await API.post("/admin/auth/login", {
//         email,
//         password,
//       });
//       localStorage.setItem("admin_token", data.token);
//       toast.success("Login successful");
//       window.location.href = "/dashboard";
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Login failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 📧 SEND OTP
//   const sendOtp = async () => {
//     if (!email) return toast.error("Email is required");
//     try {
//       setLoading(true);
//       await API.post("/admin/auth/forgot-password", { email });
//       toast.success("OTP sent to email");
//       setStep(2);
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to send OTP");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🔁 RESET PASSWORD
//   const resetPassword = async () => {
//     if (!otp || !newPassword) {
//       return toast.error("OTP and new password required");
//     }
//     try {
//       setLoading(true);
//       await API.post("/admin/auth/reset-password", {
//         email,
//         otp,
//         newPassword,
//       });
//       toast.success("Password updated. Please login.");
//       setShowForgot(false);
//       setStep(1);
//       setOtp("");
//       setNewPassword("");
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Reset failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-gray-100 text-black dark:bg-black dark:text-white min-h-screen">
      
//       {/* ================= HEADER ================= */}
//       {/* HEADER */}
//       <header className="bg-white text-black dark:bg-black dark:text-white flex items-center justify-between px-16 py-4 border-b border-black/10 dark:border-white/10">
//         <img src={WLogo} className="h-8 dark:hidden block" alt="Travelxoxo Logo" />
//         <img src={DLogo} className="h-8 hidden dark:block" alt="Travelxoxo Logo" />

//         <nav className="hidden md:flex gap-6 text-black/70 dark:text-white/70 text-sm">
//           <a href="#why" className="hover:text-black dark:hover:text-white">Why Tags</a>
//           <a href="#workflow" className="hover:text-black dark:hover:text-white">How it works</a>
//           <a href="#start" className="hover:text-black dark:hover:text-white">Get Started</a>
//           <Link to="/requestform" className="hover:text-black dark:hover:text-white">Request Stickers</Link>
//         </nav>

//         <button
//           onClick={toggleTheme}
//           className="w-12 h-12 rounded-full bg-orange-600 text-white flex items-center justify-center hover:scale-105 transition"
//         >
//           {theme === "dark" ? "🌞" : "🌙"}
//         </button>
//       </header>

//       {/* ================= MAIN CONTENT ================= */}
//       <main className="flex-1 flex items-center justify-center px-4 py-12">
//         <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-xl shadow-pink-500/10 border border-pink-50">
//           <h2 className="text-2xl font-bold text-slate-800 mb-2">Admin Login</h2>
//           <p className="text-sm text-slate-500 mb-6">Access the management dashboard</p>

//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div>
//               <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Admin Email</label>
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="admin@qrscripts.com"
//                 className="w-full rounded-xl border border-slate-200 px-4 py-3 mt-1 focus:ring-2 focus:ring-pink-400 outline-none transition"
//                 required
//               />
//             </div>

//             <div>
//               <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Password</label>
//               <div className="relative mt-1">
//                 <input
//                   type={show ? "text" : "password"}
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="••••••••"
//                   className="w-full rounded-xl border border-slate-200 px-4 py-3 pr-10 focus:ring-2 focus:ring-pink-400 outline-none transition"
//                   required
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShow(!show)}
//                   className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-pink-500 transition"
//                 >
//                   {show ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
//                 </button>
//               </div>
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-pink-600 hover:bg-pink-700 text-white py-3 rounded-xl font-bold shadow-lg shadow-pink-500/20 transition-all active:scale-95 disabled:opacity-50"
//             >
//               {loading ? "Logging in…" : "Sign In to Dashboard"}
//             </button>
//           </form>

//           <p
//             onClick={() => setShowForgot(true)}
//             className="text-center text-sm font-semibold text-pink-600 mt-6 cursor-pointer hover:underline"
//           >
//             Forgot password?
//           </p>
//         </div>
//       </main>

//       {/* ================= FOOTER ================= */}
//        <footer className="bg-white dark:bg-black border-t border-black/10 dark:border-white/10 py-8">
//   <div className="max-w-5xl mx-auto px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-black/60 dark:text-white/60">

//     <div>
//       © {new Date().getFullYear()} TravelXOXO. All rights reserved.
//     </div>

//     <div className="flex gap-6">
//       <Link
//         to="/privacypolicy"
//         className="hover:text-black dark:hover:text-white transition"
//       >
//         Privacy Policy
//       </Link>
//       <Link
//         to="/terms"
//         className="hover:text-black dark:hover:text-white transition"
//       >
//         Terms of Use
//       </Link>
//     </div>

//   </div>
// </footer>

//       {/* RESET PASSWORD MODAL */}
//      {showForgot && (
//   <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//     <div className="bg-white w-full max-w-sm rounded-3xl overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200 relative">
      
//       {/* Decorative Gradient Bar at the top */}
//       {/* <div className="h-2 w-full bg-gradient-to-r from-pink-500 via-pink-400 to-purple-600"></div> */}

//       {/* Close Button Icon */}
//       <button 
//         onClick={() => { setShowForgot(false); setStep(1); }}
//         className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors"
//       >
//         <FiX size={20} />
//       </button>

//       <div className="p-8">
//         <h2 className="text-2xl font-bold text-slate-800 mb-2">
//           Reset Password
//         </h2>
//         <p className="text-xs text-slate-500 mb-6 leading-relaxed">
//           {step === 1 
//             ? "Enter your admin email to receive a secure verification code." 
//             : "Enter the code sent to your email and choose a strong new password."}
//         </p>

//         {step === 1 && (
//           <div className="space-y-4">
//             <div>
//               <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-1">Admin Email</label>
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="Confirm your email"
//                 className="w-full border border-slate-200 rounded-xl px-4 py-3 mt-1 focus:ring-2 focus:ring-pink-400 outline-none transition-all shadow-sm"
//               />
//             </div>
//             <button
//               onClick={sendOtp}
//               disabled={loading}
//               className="w-full bg-pink-600 hover:bg-pink-700 text-white py-3 rounded-xl font-bold shadow-lg shadow-pink-500/20 transition-all active:scale-95 disabled:opacity-50"
//             >
//               {loading ? "Sending..." : "Send OTP"}
//             </button>
//           </div>
//         )}

       

//         {step === 2 && (
//   <div className="space-y-4">
//     {/* Verification Code Input */}
//     <div>
//       <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-1">
//         Verification Code
//       </label>
//       <input
//         value={otp}
//         onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
//         maxLength={6}
//         placeholder="0 0 0 0 0"
//         className="w-full border border-slate-200 rounded-xl px-4 py-3 mt-1 text-center tracking-[0.5em] text-lg font-bold focus:ring-2 focus:ring-pink-400 outline-none shadow-sm"
//       />
//     </div>

//     {/* New Password Input with Eye Icon */}
//     <div>
//       <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-1">
//         New Password
//       </label>
//       <div className="relative mt-1">
//         <input
//           type={showNewPassword ? "text" : "password"}
//           value={newPassword}
//           onChange={(e) => setNewPassword(e.target.value)}
//           placeholder="••••••••"
//           className="w-full border border-slate-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-pink-400 outline-none shadow-sm transition-all"
//         />
//         <button
//           type="button"
//           onClick={() => setShowNewPassword(!showNewPassword)}
//           className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-pink-500 transition-colors focus:outline-none"
//         >
//           {showNewPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
//         </button>
//       </div>
//     </div>

//     {/* Update Button */}
//     <button
//       onClick={resetPassword}
//       disabled={loading}
//       className="w-full bg-pink-600 hover:bg-pink-700 text-white py-3 rounded-xl font-bold shadow-lg shadow-pink-500/20 transition-all active:scale-95 disabled:opacity-50"
//     >
//       {loading ? "Updating..." : "Update Password"}
//     </button>
//   </div>
// )}

//         <button
//           onClick={() => {
//             setShowForgot(false);
//             setStep(1);
//           }}
//           className="w-full mt-6 text-sm font-semibold text-slate-400 hover:text-pink-600 transition-colors"
//         >
//           Back to Login
//         </button>
//       </div>
//     </div>
//   </div>
// )}
//     </div>
//   );
// };

// export default AdminLogin;

import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import API from "../api/config";

import WLogo from "../assets/TravelXOXO 1.png";
import DLogo from "../assets/TravelXOXO 2.png";

const AdminLogin = () => {
  /* ================= THEME ================= */
  const [theme, setTheme] = useState("dark");

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  useEffect(() => {
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
  }, [theme]);

  /* ================= FORM STATE ================= */
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ================= FORGOT PASSWORD ================= */
  const [showForgot, setShowForgot] = useState(false);
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);

  /* ================= LOGIN ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post("/admin/auth/login", {
        email,
        password,
      });
      localStorage.setItem("admin_token", data.token);
      toast.success("Login successful");
      window.location.href = "/dashboard";
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  /* ================= SEND OTP ================= */
  const sendOtp = async () => {
    if (!email) return toast.error("Email required");
    try {
      setLoading(true);
      await API.post("/admin/auth/forgot-password", { email });
      toast.success("OTP sent to email");
      setStep(2);
    } catch (err) {
      toast.error("Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  /* ================= RESET PASSWORD ================= */
  const resetPassword = async () => {
    if (!otp || !newPassword) {
      return toast.error("OTP and new password required");
    }
    try {
      setLoading(true);
      await API.post("/admin/auth/reset-password", {
        email,
        otp,
        newPassword,
      });
      toast.success("Password updated");
      setShowForgot(false);
      setStep(1);
      setOtp("");
      setNewPassword("");
    } catch {
      toast.error("Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-gray-900 dark:bg-black dark:text-white transition-colors">

      {/* ================= HEADER ================= */}
      <header className="border-b border-gray-200 dark:border-white/10 bg-white/90 dark:bg-black/90 backdrop-blur">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
          <img src={WLogo} className="h-8 dark:hidden" alt="TravelXOXO" />
          <img src={DLogo} className="h-8 hidden dark:block" alt="TravelXOXO" />

          <nav className="hidden md:flex gap-8 text-sm text-gray-600 dark:text-gray-300">
            {/* <a href="#why" className="hover:text-orange-500">Why Tags</a>
            <a href="#workflow" className="hover:text-orange-500">How it works</a>
            <a href="#start" className="hover:text-orange-500">Get Started</a>
            <Link to="/requestform" className="hover:text-orange-500">
              Request Stickers
            </Link> */}
          </nav>

          <button
            onClick={toggleTheme}
            className="w-10 h-10 rounded-full bg-orange-500 text-white flex items-center justify-center hover:scale-105 transition"
          >
            {theme === "dark" ? "🌞" : "🌙"}
          </button>
        </div>
      </header>

      {/* ================= LOGIN CARD ================= */}
      <main className="flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md rounded-2xl bg-white dark:bg-[#0E0E0E]
          border border-gray-200 dark:border-white/10 shadow-xl p-8">

          <h2 className="text-2xl font-bold mb-1">Admin Login</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
            Access the management dashboard
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Your Email"
              className="w-full rounded-xl border border-gray-300 dark:border-white/20 bg-transparent px-4 py-3 text-sm focus:ring-2 focus:ring-orange-500 outline-none"
              required
            />

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full rounded-xl border border-gray-300 dark:border-white/20 bg-transparent px-4 py-3 pr-10 text-sm focus:ring-2 focus:ring-orange-500 outline-none"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-orange-500"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-semibold shadow-lg shadow-orange-500/20 transition"
            >
              {loading ? "Logging in..." : "Sign In"}
            </button>
          </form>

          <p
            onClick={() => setShowForgot(true)}
            className="text-center text-sm font-medium text-orange-500 mt-6 cursor-pointer hover:underline"
          >
            Forgot password?
          </p>
        </div>
      </main>

      {/* ================= FOOTER ================= */}
      <footer className="border-t border-gray-200 dark:border-white/10 py-6">
        <div className="max-w-6xl mx-auto px-6 flex justify-between text-sm text-gray-500 dark:text-gray-400">
          <span>© {new Date().getFullYear()} TravelXOXO</span>
          {/* <div className="flex gap-6">
            <Link to="/privacypolicy" className="hover:text-orange-500">Privacy</Link>
            <Link to="/terms" className="hover:text-orange-500">Terms</Link>
          </div> */}
        </div>
      </footer>

      {/* ================= RESET MODAL ================= */}
      {showForgot && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-[#0E0E0E] w-full max-w-sm rounded-2xl p-8 border border-gray-200 dark:border-white/10 relative">

            <button
              onClick={() => { setShowForgot(false); setStep(1); }}
              className="absolute top-4 right-4 text-gray-400 hover:text-orange-500"
            >
              <FiX size={20} />
            </button>

            <h3 className="text-xl font-bold mb-2">Reset Password</h3>

            {step === 1 && (
              <>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Confirm email"
                  className="w-full rounded-xl border border-gray-300 dark:border-white/20 bg-transparent px-4 py-3 mb-4"
                />
                <button
                  onClick={sendOtp}
                  className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold"
                >
                  Send OTP
                </button>
              </>
            )}

            {step === 2 && (
              <>
                <input
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="OTP"
                  className="w-full rounded-xl border border-gray-300 dark:border-white/20 bg-transparent px-4 py-3 mb-3"
                />
                <input
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="New password"
                  className="w-full rounded-xl border border-gray-300 dark:border-white/20 bg-transparent px-4 py-3 mb-4"
                />
                <button
                  onClick={resetPassword}
                  className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold"
                >
                  Update Password
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLogin;
